module.exports = __webpack_public_path__ + "media/images/cafe-453f5ff6defc33e20676257bede8e17d.jpg";